import UserInfo from "../UserInfo";
import { TranslateW } from "./Languages/Translate";

export const renderLbs = (weightValue, weightPrecision = 3) => `${parseFloat(Number(weightValue).toFixed(weightPrecision))} ${TranslateW('LbsUnit')}.`;

export const renderKgs = (weightValue, weightPrecision = 2) => {
    const kg = 0.453592;
    const lbsToKg = (weightValue * kg).toFixed(weightPrecision);
    return `${lbsToKg} kgs.`;
};

const badValues = [undefined, null, ""];

export const renderWeight = (weightValue, lbsWeightPrecision = 3, kgsWeightPrecision = 2 ) => {
    if (isNaN(weightValue) || badValues.includes(weightValue)) return 'N/A';
    const usersWeightUnits = UserInfo.getWeightUnits();
    return usersWeightUnits === 'Lbs' ? renderLbs(weightValue, lbsWeightPrecision) : renderKgs(weightValue, kgsWeightPrecision);
};

// Converts a value entered in the user's preferred weight unit back to lbs (the unit stored/validated by the backend).
// Inverse of renderKgs/getConvertedWeight, which use the 0.453592 lbs->kgs factor.
export const convertToLbs = (weightValue) => {
    if (isNaN(weightValue) || badValues.includes(weightValue)) return 0;
    const usersWeightUnits = UserInfo.getWeightUnits();
    return usersWeightUnits === 'Lbs' ? parseFloat(weightValue) : parseFloat(weightValue) / 0.453592;
};